import styled from 'styled-components';

export const FormContainer = styled.h1`
    padding: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #7c04a4;
`